<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>Leads列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          label-position="right"
          label-width="80px"
          size="small"
        >
          <div class="filter-block">
            <el-form-item label="Leads 名称">
              <el-input size="small" v-model="filter.name"></el-input>
            </el-form-item>
            <el-form-item label="Campaign">
              <CampaingnSelect v-model="filter.campaign_id"></CampaingnSelect>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-button
                type="primary"
                size="small"
                @click="
                  filter.page = 1
                  requestleadsList()
                "
                >筛选</el-button
              >
              <el-button size="small" @click="reset()">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table :data="lists" stripe>
        <el-table-column prop="name" label="Leads 名称" min-width="120">
        </el-table-column>
        <el-table-column label="Campaign" prop="campaign.name" min-width="100">
        </el-table-column>
        <el-table-column label="客户" prop="customer.name" min-width="100">
        </el-table-column>
        <el-table-column
          label="客户销售"
          prop="saler.name"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope">
            <el-tag type="primary" size="mini">{{
              statusMap[scope.row.status]
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
    
<script>
import { leadsList } from '@/service/getData'
import CampaingnSelect from './CampaingnSelect.vue'
export default {
  components: {
    CampaingnSelect,
  },
  data() {
    return {
      filter: {
        name: '',
        size: 10,
        page: 1,
        campaign_id: '',
      },
      lists: [],
      total: 0,
      statusMap: {
        1: 'Open',
        2: 'Qualified',
        3: 'Converted',
        5: 'Closed',
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestleadsList()
    },
  },
  created() {
    if (this.$route.query.campaign_id) {
      this.filter.campaign_id = parseInt(this.$route.query.campaign_id)
    }
    this.requestleadsList()
  },
  methods: {
    async requestleadsList() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      let data = this.clone(this.filter)
      data.page -= 1

      let res = await leadsList(data)

      this.lists = res.data.list
      this.total = res.data.total
    },
    reset() {
      this.filter.page = 1
      this.filter.name = ''
      this.filter.campaign_id = ''
      this.requestleadsList()
    },
  },
}
</script>